"use client";

import {
    Accordion,
    AccordionContent,
    AccordionItem,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { PlusIcon } from "lucide-react";
import { useTranslations } from "next-intl";

const faqKeys = [
    "ai_management",
    "cod",
    "nocode",
    "shipping",
    "security",
    "apps",
];

const FAQ = () => {
    const t = useTranslations("marketing.faq");

    return (
        <div
            id="faq"
            className="w-full max-w-7xl mx-auto py-12 md:py-20 px-6"
        >
            <div className="flex justify-center">
                <span className="inline-block mb-4 text-sm font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">
                    {t("badge")}
                </span>
            </div>
            <h2 className="md:text-center text-3xl xs:text-4xl md:text-5xl leading-[1.15]! font-semibold tracking-tighter">
                {t.rich("title", {
                    highlight: (chunks) => <span className="text-primary">{chunks}</span>
                })}
            </h2>
            <p className="mt-1.5 md:text-center xs:text-lg text-muted-foreground">
                {t("description")}
            </p>

            <div className="min-h-[550px] md:min-h-[320px] xl:min-h-[300px]">
                <Accordion
                    type="single"
                    collapsible
                    className="mt-8 space-y-4 md:columns-2 gap-4"
                >
                    {faqKeys.map((key, index) => (
                        <AccordionItem
                            key={key}
                            value={`question-${index}`}
                            className="bg-accent py-1 px-4 rounded-xl border-none mt-0! mb-4! break-inside-avoid"
                        >
                            <AccordionPrimitive.Header className="flex">
                                <AccordionPrimitive.Trigger
                                    className={cn(
                                        "flex flex-1 items-center justify-between py-4 font-semibold tracking-tight transition-all hover:underline [&[data-state=open]>svg]:rotate-45",
                                        "text-start text-lg"
                                    )}
                                >
                                    {t(`questions.${key}.q`)}
                                    <PlusIcon className="h-5 w-5 shrink-0 text-muted-foreground transition-transform duration-200 ms-2" />
                                </AccordionPrimitive.Trigger>
                            </AccordionPrimitive.Header>
                            <AccordionContent className="text-[15px]">
                                {t(`questions.${key}.a`)}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </div>
    );
};

export default FAQ;
